import { put, takeLeading } from 'redux-saga/effects';

import discoveryLocationApi from 'api/discoveryLocationApi';
import { apiErrorHandler } from 'utils';

import {
  GET_DISCOVERY_LOCATIONS,
  DELETE_DISCOVERY_LOCATION,
} from './actionTypes';
import {
  actionGetDiscoveryLocationsFailed,
  actionGetDiscoveryLocationsSuccess,
  actionDeleteDiscoveryLocationFailed,
  actionDeleteDiscoveryLocationSuccess,
} from './actions';

function* getDiscoveryLocations({ payload }) {
  try {
    const response = yield discoveryLocationApi.getDiscoveryLocations(payload);

    yield put(actionGetDiscoveryLocationsSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryLocationsFailed());
  }
}

function* deleteDiscoveryLocation({ payload }) {
  try {
    const response = yield discoveryLocationApi.deleteDiscoveryLocation(
      payload,
    );

    yield put(
      actionDeleteDiscoveryLocationSuccess({
        ...payload,
        response: response.payload,
      }),
    );

    payload?.callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionDeleteDiscoveryLocationFailed());
  }
}

export default function* discoveryLocationSaga() {
  yield takeLeading(GET_DISCOVERY_LOCATIONS, getDiscoveryLocations);
  yield takeLeading(DELETE_DISCOVERY_LOCATION, deleteDiscoveryLocation);
}
